import { useParams, useNavigate } from 'react-router-dom';
import useClock from 'hooks/useClock';
import { useEffect } from 'react';


const RequestOverviewClockOut = () => {

    const { requestKey } = useParams();
    const { currentClock, clockOut } = useClock();
    const navigate = useNavigate();

    useEffect(() => {
        if (!currentClock) {
            navigate(`/request/${requestKey}`);
            return;
        }

        // Just clock out directly and navigate back
        if (currentClock?.associated_type === 'request' && currentClock?.associated_uuid === requestKey) {
            clockOut(currentClock.key);
            navigate(`/request/${requestKey}`);
        }
    }, [currentClock, requestKey]);

    if (!requestKey)
        return null;
    if (currentClock?.associated_type !== 'request')
        return null;
    if (currentClock?.associated_uuid !== requestKey)
        return <em>Not clocked in here</em>

    return null;
}

export default RequestOverviewClockOut;
